import { useLockBodyScroll } from '@hook/useLockBodyScroll';
import { useSetSearchParams } from '@hook/useSetSearchParams';
import { useAppDispatch, type RootState } from '@store/index';
import { setIsFilterOpen } from '@store/priceSlice';
import classNames from 'classnames';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const FilterWrapTempl = ({ children, refreshObj }: { children: ReactNode; refreshObj: Record<string, string> }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const setParams = useSetSearchParams();
    const isFilterOpen = useSelector((state: RootState) => state.price.isFilterOpen);

    useLockBodyScroll(isFilterOpen);

    return (
        <div className={classNames({ 'is-active': isFilterOpen }, `gameinfo-filter-wrapper`)}>
            <div className="gameinfo-filter">
                <div className="gameinfo-filter__title">
                    <h2>{t('common.searchconditions')}</h2>
                    <button className="btn-refresh" data-areas="시세_조건검색_초기화_클릭" onClick={() => setParams(refreshObj)}>
                        refresh
                    </button>
                </div>
                <div className="gameinfo-filter__section">
                    <div className="gameinfo-filter__list">{children}</div>
                </div>
                <div className="gameinfo-filter__footer">
                    <button className="btn-close" onClick={() => dispatch(setIsFilterOpen(false))}>
                        {t('common.saveandclose')}
                    </button>
                </div>
            </div>
        </div>
    );
};
